import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

function CancelServiceModal({
  show,
  handleClose,
  hasPaymentMethod,
  endDate,
  onConfirmRemovePayment,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    return new Date(timestamp * 1000).toLocaleDateString();
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onConfirmRemovePayment();
      handleClose();
    } catch (e) {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Cancel Service</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center px-4">

        {error && (
        <div className="alert alert-danger text-center mb-4">
          {error}
        </div>
        )}
        <p>
          To cancel your service, simply remove your payment method.
          Your service will remain active through the current period.
        </p>

        {!hasPaymentMethod ? (
          <p>
            {/* eslint-disable-next-line max-len */}
            You do not have a payment method on file at this time. If you do not add a payment method,
            {' '}
            <strong className="text-danger">
              your service will automatically end on
              {' '}
              {formatDate(endDate)}
              .
            </strong>
          </p>
        ) : (
          <p>
            Do you want to remove your payment method now? If you do,
            {' '}
            <strong className="text-danger">
              your service will automatically end on
              {' '}
              {formatDate(endDate)}
              .
            </strong>
          </p>
        )}

      </Modal.Body>

      <Modal.Footer className="justify-content-center">

        {!hasPaymentMethod ? (
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            OK
          </button>
        ) : (
          <>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleSubmit}
              disabled={submitting}
            >
              Yes, remove my payment method.
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleClose}
            >
              No, keep my assets protected.
            </button>
          </>
        )}

      </Modal.Footer>
    </Modal>
  );
}

CancelServiceModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  hasPaymentMethod: PropTypes.bool.isRequired,
  endDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onConfirmRemovePayment: PropTypes.func.isRequired,
};

CancelServiceModal.defaultProps = {
  endDate: null,
};

export default CancelServiceModal;
